// extracted by mini-css-extract-plugin
export var body = "index-module--body--8099b";
export var details_container = "index-module--details_container--dddc1";
export var details_wrapper = "index-module--details_wrapper--e7df7";
export var heading = "index-module--heading--2824e";
export var heading_text = "index-module--heading_text--14ab9";